var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioUncheckable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.998 3C13.247 3 14.4149 3.23651 15.5059 3.70703C16.6063 4.18171 17.5586 4.82358 18.3672 5.63184C19.0748 6.33914 19.6543 7.15667 20.1064 8.08691L20.293 8.49219C20.7635 9.58245 21 10.7494 21 11.998C21 13.247 20.7635 14.4149 20.293 15.5059C19.8183 16.6063 19.1764 17.5586 18.3682 18.3672C17.6609 19.0748 16.8433 19.6543 15.9131 20.1064L15.5078 20.293C14.4175 20.7635 13.2506 21 12.002 21C10.753 21 9.58505 20.7635 8.49414 20.293C7.39368 19.8183 6.44138 19.1764 5.63281 18.3682C4.92524 17.6609 4.34571 16.8433 3.89355 15.9131L3.70703 15.5078C3.23645 14.4175 3.00003 13.2506 3 12.002C3 10.753 3.23651 9.58505 3.70703 8.49414C4.18171 7.39368 4.82359 6.44138 5.63184 5.63281C6.33914 4.92524 7.15667 4.34571 8.08691 3.89355L8.49219 3.70703C9.58245 3.23645 10.7494 3.00003 11.998 3Z",
    fill: "#E5E8F0",
    stroke: "#A7B0C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioUncheckable);
export default __webpack_public_path__ + "static/media/radio_uncheckable.23eeeaab56c27429b8d1941d077cd00e.svg";
export { ForwardRef as ReactComponent };